import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_departure_feedbacks_real'

export default {
  state: {
    feedbacks: []
  },
  mutations: {
    SET_FEEDBACKS(state, list) {
      state.feedbacks = list
      storage.set(STORAGE_KEY, list)
    },
    ADD_FEEDBACK(state, item) {
      state.feedbacks.push(item)
      storage.set(STORAGE_KEY, state.feedbacks)
    },
    UPDATE_FEEDBACK(state, item) {
      const idx = state.feedbacks.findIndex(f => f.feedback_id === item.feedback_id)
      if (idx >= 0) {
        state.feedbacks.splice(idx, 1, item)
        storage.set(STORAGE_KEY, state.feedbacks)
      }
    },
    DELETE_FEEDBACK(state, id) {
      state.feedbacks = state.feedbacks.filter(f => f.feedback_id !== id)
      storage.set(STORAGE_KEY, state.feedbacks)
    }
  },
  getters: {
    allFeedbacks: state => state.feedbacks,
    feedbacksByManager: state => email => state.feedbacks.filter(f => f.manager_email === email),
    feedbacksByEmployee: state => id => state.feedbacks.filter(f => f.employee_id === id)
  }
}
